import { formatDate } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { DATE_TIME, DRAWER_NOW, SAST, friendlyTimes } from './integration-status.util';

/**
 * Times in the integration drawer, easier to read (Heinrich, 28/10/2026): an instant shown in SAST as
 * yyyy-MM-dd HH:mm, or a line of the server's text, with a time from today or yesterday said that way,
 * e.g. "Last pull today 22:46". Older times keep the full date.
 */
@Pipe({ name: 'drawerTime', standalone: false })
export class DrawerTimePipe implements PipeTransform {
  private readonly now = inject(DRAWER_NOW);

  transform(value: string | Date | null | undefined, kind: 'instant' | 'text' = 'instant'): string {
    if (value == null || value === '') return '';
    const text = kind === 'instant' ? formatDate(value, DATE_TIME, 'en-ZA', SAST) : String(value);
    return friendlyTimes(text, this.now());
  }
}
